module.exports = __webpack_public_path__ + "img/ico-rule.6a6bc8dc.png";